import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO, BreadcrumbSchema } from '../components/SEO';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

export default function ContactPage() {
  const breadcrumbs = [
    { name: 'Home', path: '/' },
    { name: 'Contact', path: '/contact' }
  ];

  const contactInfo = [
    {
      icon: Phone,
      title: 'Phone',
      value: '(321) 210-2777',
      link: 'tel:+13212102777',
    },
    {
      icon: Mail,
      title: 'Email',
      value: 'lead@renonovo.com',
      link: 'mailto:lead@renonovo.com',
    },
    {
      icon: MapPin,
      title: 'Address',
      value: 'RenoNovo, LLC\n1790 Hwy A1A, Suite 209\nSatellite Beach, FL 32937',
      link: 'https://maps.google.com/?q=1790+Hwy+A1A+Suite+209+Satellite+Beach+FL+32937',
    },
    {
      icon: Clock,
      title: 'Hours',
      value: 'Mon-Fri 9am-6pm EST',
      link: null,
    },
  ];

  return (
    <div className="min-h-screen" data-testid="contact-page">
      <SEO 
        title="Contact RenoNovo - Book Your Free Strategy Call"
        description="Contact RenoNovo to start getting exclusive appointments for your home service business. Call (321) 210-2777 or fill out our form. Located in Satellite Beach, FL."
        keywords="contact RenoNovo, book strategy call, contractor marketing consultation, home service leads contact"
        canonical="/contact"
      />
      <BreadcrumbSchema items={breadcrumbs} />
      <Header />
      <main>
        {/* Hero Section */}
        <section className="pt-32 pb-8 md:pt-40 md:pb-12 bg-[#f8fafc]">
          <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 text-center">
            <p className="text-sm tracking-wide uppercase font-semibold text-[#2563eb] mb-4">
              Get Started
            </p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[#0f172a] tracking-tight leading-tight mb-6">
              Let's Grow Your Business Together
            </h1>
            <p className="text-lg text-[#64748b] leading-relaxed max-w-2xl mx-auto">
              Fill out the form below and our team will reach out to schedule your 
              free strategy call. No obligation — just valuable insights.
            </p>
          </div>
        </section>

        {/* Contact Form & Info */}
        <section className="py-12 md:py-16">
          <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
              {/* Contact Info Sidebar */}
              <div className="lg:col-span-1 space-y-8">
                <div>
                  <h2 className="text-2xl font-bold text-[#0f172a] mb-4">Contact Information</h2>
                  <p className="text-[#64748b]">
                    Have questions? Reach out directly or fill out the form and we'll get back 
                    to you within 24 hours.
                  </p>
                </div>

                <div className="space-y-6">
                  {contactInfo.map((item) => (
                    <div key={item.title} className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-[#2563eb]/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <item.icon className="w-5 h-5 text-[#2563eb]" />
                      </div>
                      <div>
                        <p className="text-sm text-[#64748b]">{item.title}</p>
                        {item.link ? (
                          <a 
                            href={item.link}
                            className="text-[#0f172a] font-semibold hover:text-[#2563eb] transition-colors duration-200 whitespace-pre-line"
                            data-testid={`contact-${item.title.toLowerCase()}`}
                          >
                            {item.value}
                          </a>
                        ) : (
                          <p className="text-[#0f172a] font-semibold whitespace-pre-line">{item.value}</p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Embedded Form */}
              <div className="lg:col-span-2">
                <div className="bg-white rounded-sm shadow-[0_4px_20px_rgba(15,23,42,0.08)] overflow-hidden">
                  <iframe
                    src="https://link.msgsndr.com/widget/form/5Lrly5d1gsvY2agn8U2l"
                    style={{ width: '100%', height: '1000px', border: 'none' }}
                    id="contact-form"
                    data-testid="contact-form"
                    title="Contact Form"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
